import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { recoverPassword, userForgetPassword } from "../../slices/thunks";

// import images
// import profile from "../../assets/images/bg.png";
import logoLight from "../../assets/images/logo-light.png";
import logoAiCare from "../../assets/images/pn.png";
import logoAiCareEsteso from "../../assets/images/aicare.png";
import loghiNazionali from "../../assets/images/loghi-nazionali.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";

const ForgetPasswordPage = (props: any) => {
  const dispatch: any = useDispatch();
  const [loader, setLoader] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      setSuccess(false);
      setError(false);

      setLoader(true);
      dispatch(recoverPassword(values, setSuccess, setError));
      setLoader(false);
    },
  });

  useEffect(() => {
    if (success) {
      setTimeout(() => setSuccess(false), 10000);
    }

    setTimeout(() => {
      setError(false);
    }, 10000);
  }, [success, error]);

  document.title = "Reset Password";
  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <div
          className="mb-lg-5"
          style={{ textAlign: "center", backgroundColor: "#fff" }}
        >
          <span className="logo-lg">
            <img
              src={loghiNazionali}
              alt=""
              className="img-fluid"
              style={{ minHeight: 30, maxHeight: 80 }}
            />
          </span>
        </div>
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoAiCare} alt="" height="45" />
                      <img src={logoAiCareEsteso} alt="" height="45" />
                    </Link>
                  </Link>
                </div>
                <p className="mt-3 fs-15 fw-medium">Dashboard AICare</p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">
                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Password Dimenticata?</h5>
                    <p className="text-muted">Reset Password</p>

                    <i className="ri-mail-send-line display-5 text-success mb-3"></i>
                  </div>

                  {error === false && success === false && (
                    <Alert
                      className="border-0 alert-warning text-center mb-2 mx-2"
                      role="alert"
                    >
                      Inserisci la tua email e ti verranno inviate le
                      istruzioni!
                    </Alert>
                  )}
                  <div className="p-2">
                    {success && success ? (
                      <>
                        <Alert color="success">
                          Le istruzioni per il recupero della password sono
                          state inviate con successo!
                        </Alert>
                      </>
                    ) : null}

                    {error && error ? (
                      <Alert color="danger">
                        <div>
                          Impossibile recuperare l'account associato all'email
                          inserita! Assicurati che l'email sia corretta e
                          riprova.
                        </div>
                      </Alert>
                    ) : null}
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            <div>{validation.errors.email}</div>
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <button className="btn btn-soft-danger" type="submit">
                          Invia Link di Reset
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0">
                  Aspetta ora ricordo la password ...{" "}
                  <Link
                    to="/login"
                    className="fw-semibold text-primary text-decoration-underline"
                  >
                    {" "}
                    Clicca qui{" "}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
